// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#loading{min-height:200px;display:flex;align-items:center}.el-loading-spinner .path{stroke:#66615b!important}.el-loading-mask{background:transparent!important}", ""]);
// Exports
module.exports = exports;
